<!-- /////////////////////////////////////////////////////////////////////////// TEMPLATE -->

<template>

    <div class="sl-form-dual__line sl-form-dual__line-grouped">

    </div>

</template>

<!-- /////////////////////////////////////////////////////////////////////////// SCRIPT -->

<script>

export default
{
    name: 'FormLineGrouped',

    props:
    {
        formLine:
        {
            type:     Object,
            required: true,
        },
    },

    computed:
    {

    },

    methods:
    {

    },
};

</script>

<!-- /////////////////////////////////////////////////////////////////////////// STYLE -->

<style lang="scss">

</style>
